import React from "react";
import DMModal from "./DMModal";
import CloseIcon from "@material-ui/icons/Close";
import { Divider } from "@material-ui/core";

export default function PublishModel({
  open = false,
  onClose = () => {},
  model = null,
}) {
  return (
    <DMModal open={open} onClose={onClose}>
      <div style={styles.popup}>
        <div style={{ display: "flex", marginBottom: "10px" }}>
          <div
            style={{
              flex: "1",
              fontSize: "16px",
              fontWeight: "700",
              textAlign: "left",
            }}
          >
            Publish New Version
          </div>
          <div>
            <CloseIcon
              style={{
                marginBottom: "-6px",
                paddingLeft: "4px",
                color: "#BAC0D0",
                cursor: "pointer",
              }}
              fontSize="small"
              onClick={onClose}
            />
          </div>
        </div>
        <Divider />
        <div style={styles.content}>
          <div style={styles.field}>
            <label style={styles.label}>Model :</label>
            <span style={styles.text}>{model?.modelName || "-"}</span>
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Version :</label>
            <span style={styles.text}>V{model?.version || "1.0"}</span>
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label style={styles.label}>Description</label>
            <textarea
              style={styles.textarea}
              placeholder="New version description"
            ></textarea>
            <div style={styles.warningText}>
              This version will replace current live version (V1.0)
            </div>
          </div>

          <button style={styles.button} onClick={onClose}>
            Publish
          </button>
        </div>
      </div>
    </DMModal>
  );
}

const styles = {
  popup: {
    width: "450px",
    backgroundColor: "white",
    borderRadius: "10px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    padding: "20px",
    textAlign: "center",
    margin: "200px auto",
    outline: "none",
    fontFamily: "Roboto",
  },
  header: {
    marginBottom: "20px",
    fontSize: "18px",
    color: "#333",
  },
  content: {
    textAlign: "left",
    marginTop: "15px",
  },
  field: {
    marginBottom: "15px",
    display: "flex",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
    color: "#333",
  },
  text: {
    color: "#333",
    fontWeight: "500",
    marginLeft: "10px",
  },
  textarea: {
    width: "-webkit-fill-available",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    fontSize: "14px",
    resize: "none",
    height: "50px",
  },
  button: {
    width: "100%",
    padding: "10px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  warningText: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "400",
    color: "#EB5623",
  },
};
